import api from "./api/api";

const serviceProspect = {
  getProdutosProspect: async () => {
    try {
      const res = await api.get(`/produtoProspect`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getStatusProspect: async (params: Record<string, any> = {}) => {
    try {
      const res = await api.get(`/statusProspect`, { params });
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getProspect: async (
    page: any,
    perPage: any,
    search = "",
    agenciasId: number[] = [],
    clientesId: number[] = [],
    statusId: number[] = [],
    productsId: number[] = [],
    responsavelId: any = "",
    meses: number[] = [],
    ano: string = "",
    lotes: string[] = [],
  ) => {
    try {
      const params: Record<string, any> = {
        page,
        perPage,
      };

      if (search) params.s = search;
      if (productsId.length) params.product_id = productsId.join(",");
      if (agenciasId.length) params.agency_id = agenciasId.join(",");
      if (clientesId.length) params.client_id = clientesId.join(",");
      if (statusId.length) params.status_id = statusId.join(",");
      if (responsavelId) params.responsavel_id = responsavelId;
      if (meses.length) params.mes = meses.join(",");
      if (ano) params.ano = ano;
      if (lotes.length) params.lote = lotes.join(",");

      const queryString = new URLSearchParams(params as any).toString();

      const res = await api.get(`/prospectings?${queryString}`);

      return res.data;
    } catch (error: any) {
      return error.response;
    }
  },
  getProspectById: async (id: any) => {
    try {
      const res = await api.get(`/prospectings/${id}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  addProspect: async (payload: any) => {
    try {
      const res = await api.post(`/prospectings`, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  editProspect: async (id_negocio: any, payload: any) => {
    try {
      const res = await api.put(`/prospectings/${id_negocio}`, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  deleteProspect: async (id_negocio: any) => {
    try {
      const res = await api.delete(`/prospectings/${id_negocio}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  sendProspectingEmail: async (
    prospectingId: number,
    payload: { subject: string; body: string; recipients: string[] },
  ) => {
    try {
      const res = await api.post(
        `/prospecting-emails/send/${prospectingId}`,
        payload,
      );
      return res.data;
    } catch (error: any) {
      return error.response?.data ?? error;
    }
  },
  getEmailHistory: async (prospectingId: number) => {
    try {
      const res = await api.get(`/prospecting-emails/history/${prospectingId}`);
      return res.data;
    } catch (error: any) {
      return error.response?.data ?? error;
    }
  },
  getLotes: async (): Promise<{ lote: string; count: number }[]> => {
    try {
      const res = await api.get(`/prospectings/lotes/list`);
      return res.data?.data ?? [];
    } catch (error: any) {
      return [];
    }
  },
  deleteLote: async (lote: string) => {
    try {
      const res = await api.delete(
        `/prospectings/lotes/${encodeURIComponent(lote)}`,
      );
      return res;
    } catch (error: any) {
      return error.response;
    }
  },

  getOutboundProspects: async (params: Record<string, any> = {}) => {
    try {
      const res = await api.get(`/prospectings`, {
        params: { ...params, source_type: "outbound" },
      });
      return res.data;
    } catch (error: any) {
      return error.response;
    }
  },

  // ─── Inbound ────────────────────────────────────────────────────────────────

  getInboundProspects: async (params: Record<string, any> = {}) => {
    try {
      const res = await api.get(`/prospectings`, {
        params: { ...params, source_type: "inbound" },
      });
      return res.data;
    } catch (error: any) {
      return error.response;
    }
  },

  getInboundLeads: async (params: Record<string, any> = {}) => {
    return serviceProspect.getInboundProspects(params);
  },

  getInboundStatuses: async () => {
    try {
      const res = await api.get(`/prospectings/statuses`, {
        params: { source_type: "inbound" },
      });
      return res.data;
    } catch (error: any) {
      return error.response;
    }
  },

  getProspectStatusesBySource: async (sourceType: "outbound" | "inbound") => {
    try {
      const res = await api.get(`/statusProspect`, {
        params: { source_type: sourceType },
      });
      return res.data;
    } catch (error: any) {
      return error.response;
    }
  },

  moveInboundLead: async (
    prospectingId: number,
    payload: number | { status_id: number; lost_reason?: string | null },
  ) => {
    try {
      const body = typeof payload === "number" ? { status_id: payload } : payload;
      const res = await api.patch(`/prospectings/${prospectingId}/status`, body);
      return res.data;
    } catch (error: any) {
      return error.response?.data ?? error.response;
    }
  },

  updateInboundResponsavel: async (
    prospectingId: number,
    payload: { responsavel_id: number | null },
  ) => {
    try {
      const res = await api.patch(
        `/prospectings/${prospectingId}/responsavel`,
        payload,
      );
      return res.data;
    } catch (error: any) {
      return error.response;
    }
  },

  convertInboundToDesk: async (prospectingId: number, payload: any) => {
    try {
      const res = await api.post(
        `/prospectings/${prospectingId}/convert-to-desk`,
        payload,
      );
      return res.data;
    } catch (error: any) {
      return error.response?.data ?? error.response;
    }
  },

  // ─── Formulários Inbound ────────────────────────────────────────────────────

  getInboundForms: async (params: Record<string, any> = {}) => {
    try {
      const res = await api.get(`/prospecting-forms?page=1&per_page=10`, { params });
      return res.data;
    } catch (error: any) {
      return error.response;
    }
  },

  getInboundFormById: async (id: number) => {
    try {
      const res = await api.get(`/prospecting-forms/${id}`);
      return res.data;
    } catch (error: any) {
      return error.response;
    }
  },

  getInboundForm: async (id: number) => {
    return serviceProspect.getInboundFormById(id);
  },

  createInboundForm: async (payload: any) => {
    try {
      const res = await api.post(`/prospecting-forms`, payload);
      return res.data;
    } catch (error: any) {
      return error.response?.data ?? error.response;
    }
  },

  updateInboundForm: async (id: number, payload: any) => {
    try {
      const res = await api.put(`/prospecting-forms/${id}`, payload);
      return res.data;
    } catch (error: any) {
      return error.response?.data ?? error.response;
    }
  },

  toggleInboundForm: async (id: number, active: boolean) => {
    try {
      const res = await api.patch(`/prospecting-forms/${id}/active`, { active });
      return res.data;
    } catch (error: any) {
      return error.response?.data ?? error.response;
    }
  },

  deleteInboundForm: async (id: number) => {
    try {
      const res = await api.delete(`/prospecting-forms/${id}`);
      return res.data;
    } catch (error: any) {
      return error.response?.data ?? error.response;
    }
  },

  getPublicInboundForm: async (publicKey: string) => {
    try {
      const res = await api.get(`/public/prospecting-forms/${publicKey}`, {
        headers: { withoutAuth: true },
      });
      return res.data;
    } catch (error: any) {
      return error.response?.data ?? error.response;
    }
  },

  submitPublicInboundForm: async (
    publicKey: string,
    payload: Record<string, any>,
  ) => {
    try {
      const res = await api.post(
        `/public/prospecting-forms/${publicKey}/submissions`,
        payload,
        { headers: { withoutAuth: true } },
      );
      return res.data;
    } catch (error: any) {
      return error.response?.data ?? error.response;
    }
  },
};

export default serviceProspect;
